<template>
    <section class="w-full h-full flex py-12" v-if="initialLoading">
        <section class="rounded-lg mt-40 text-gray-300 flex items-center flex-col w-full h-min ">
            <span class="animate-spin material-icons-outlined text-center dark:text-gray-300 select-none text-9xl ">
                autorenew
            </span>
            <p class="text-4xl text-center animate-pulse">Preparando pesquisa...</p>
        </section>
    </section>
    <div v-else class="w-full md:w-4/5 mx-auto mt-4 flex py-8 flex-wrap ">
        <Remove v-if="removeModal" @changeVisibility="removeModal = false" @remove="remove()"/>
        <Adicionar :loja="loja" v-if="addModal"/>
        <Finalizar v-if="finalizarModal" @changeVisibility="finalizarModal = false" @finalizar="finalizar()"/>
        <div class="w-full flex flex-row-reverse">
            <button v-if="!addModal && editRecolha" @click="addModal = true" class="btn py-2 px-4 bg-indigo-500 rounded-lg text-gray-100 uppercase text-sm">+ Adicionar</button>
            <button v-else-if="addModal" @click="addModal = false; getProducts()" class="btn py-2 px-4 bg-indigo-500 rounded-lg text-gray-100 uppercase text-sm">Concluir</button>
        </div>
        <div v-if="!addModal" class="flex flex-row flex-wrap gap-x-4 w-full ">
            <div class="pt-2 flex-1 h-auto sticky rounded-lg">
                <div class="w-4/5 m-auto py-4 flex flex-col gap-y-4">
                    <p class="text-2xl dark:text-gray-300 text-gray-700">Filtros</p>
                    <span class="w-full md:flex-1">
                        <Autocomplete v-model="marca" label="Marca" placeholder="Selecionar marca" :list="marcas" desc="marca" @filter="filterByMarca()"/>
                    </span>
                    <span class="w-full md:flex-1">
                        <Autocomplete v-model="modelo" label="Modelo" placeholder="Selecionar modelo" :list="modelos" desc="descricao" @filter="filterByModelo()"/>
                    </span>

                    <span class="w-full md:flex-1">
                        <p class="uppercase text-gray-300 text-xs"> </p>
                        <Input v-model="searchComplemento" label="Pesquisar complemento"/>
                    </span>
                </div>
            </div>
            <div id="lojas-section" class="w-3/4 flex-none flex flex-col flex-wrap gap-y-4 mt-2 overflow-y-scroll ">
                <div class="h-auto overflow-y-scroll px-4 py-2 rounded-xl flex w-full gap-x-4 text-gray-600 dark:text-gray-300 uppercase text-sm">
                    <p class="self-center flex-1 flex-shrink ">Marca</p>
                    <p class="self-center flex-1 flex-shrink">Modelo</p>
                    <p class="self-center w-1/5 flex-grow break-normal whitespace-normal text-sm">Complemento</p>
                    <p class="self-center w-1/12 flex-shrink">Preço médio</p>
                    <p class="self-center w-1/6 flex-shrink">Preço atual</p>
                    <p class="self-center w-1/12 flex-shrink">Quantidade</p>
                    <p v-if="editRecolha" class="self-center w-14 flex-shrink"></p>
                </div>
                <div class="flex-1 max-h-96 overflow-y-scrollpy-2 rounded-xl">
                    <div v-for="produto, i in filteredListProducts" :key="i"
                    class="flex px-4 w-full rounded-lg gap-x-4 mb-1 bg-gray-100 dark:bg-gray-800 bg-opacity-40 border border-gray-300 dark:border-gray-800 shadow-md h-16  text-gray-500 dark:text-gray-200">
                        <p class="self-center flex-1 break-normal whitespace-normal flex-shrink text-sm">{{produto.marca ? produto.marca : produto.marca_descricao}} </p>
                        <p class="self-center flex-1 break-normal whitespace-normal flex-shrink text-sm">{{produto.modelo ? produto.modelo : produto.modelo_descricao}}</p>
                        <p class="self-center w-1/5 flex-grow break-normal whitespace-normal text-sm">{{produto.complemento}}</p>
                        <div class="self-center w-1/12 relative h-12">
                            <money3 class="hidden" v-model="produto.preco_medio" v-bind="config"></money3>
                            <input disabled=true v-money3="config" v-model="produto.preco_medio" placeholder="0,00" class="w-full h-full pl-7 bg-transparent rounded-lg placeholder-gray-500 ring ring-transparent focus:ring-indigo-500"/>
                            <label class="absolute top-3 select-none ">R$</label>
                        </div>
                        <div class="self-center w-1/6 relative h-12">
                            <money3 class="hidden" v-model="produto.valor" v-bind="config"></money3>
                            <input :disabled="!editRecolha" v-money3="config" min="0" v-model="produto.valor" class="w-full h-full pl-8 bg-transparent rounded-lg placeholder-gray-500 ring disabled:ring-transparent transition-all duration-500 ring-indigo-100 focus:ring-indigo-500" type="text"/>
                            <label class="absolute top-3 ml-1 select-none ">R$</label>
                            <div :class=" produto.valor > (1.2*produto.preco_medio) ? 'text-red-600' : 'text-yellow-500' " class="flex text-xs gap-x-1 items-center absolute top-3/4 -mt-1 w-full break-normal whitespace-nowrap" v-if="produto.preco_medio !== '0.00' && produto.valor !== '0.00' && (produto.valor > (1.2*produto.preco_medio) || produto.valor < (0.8*produto.preco_medio))">
                                <span class="material-icons-outlined">
                                    {{produto.valor > (1.2*produto.preco_medio) ? 'trending_up' : 'trending_down'}}
                                </span>
                                <p>{{percentCalc(produto)}}</p>
                            </div>
                        </div>
                        <div class="self-center w-1/12 relative h-12">
                            <input :disabled="!editRecolha" min="0" type="text" v-model.lazy="produto.quantidade" class="w-full h-full bg-transparent rounded-lg placeholder-gray-500 ring disabled:ring-transparent transition-all duration-500 ring-indigo-100 focus:ring-indigo-500 pl-2"/>
                        </div>
                        <button v-if="editRecolha" tabindex="-1" @click="openRemoveModal(produto.marca_id, produto.modelo_id, produto.complemento_id)" class="btn text-indigo-500 self-center w-14 flex-shrink text-xs">REMOVER</button>
                    </div>
                </div>
            </div>
            <span v-if="hasRecolha" class="w-full mt-8">
                <div v-if="!editRecolha" >
                    <button v-if="userViewer.role === 'administrador' || recolha.recolha.editavel === 'true'" @click="editRecolha = true" class="btn w-full inline-flex justify-center rounded-md shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 sm:ml-3 sm:w-auto sm:text-sm" :disabled="loading">
                        Editar recolha
                    </button>
                </div>
                <div v-if="editRecolha" class="w-full mt-8">
                    <button @click="editRecolha = false; cancelEdit()" class="btn w-full inline-flex justify-center rounded-md text-base font-medium text-gray-700 bg-transparent shadow-none dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 sm:ml-3 sm:w-auto sm:text-sm" :disabled="loading">
                        Cancelar alterações
                    </button>
                    <button v-if="recolha.recolha.editavel === 'true'" @click="editRecolha = false; wip()" class="btn w-full inline-flex justify-center rounded-md shadow-sm px-4 py-2 bg-gray-100 hover:bg-gray-200 dark:hover:bg-gray-300 text-base font-medium border dark:border-0 border-indigo-600 text-indigo-600 focus:outline-none focus:ring-2 focus:ring-offset-2 sm:ml-3 sm:w-auto sm:text-sm" :disabled="loading">
                        <span :class="loading ? 'animate-pulse' : ''"> {{loading ? 'Salvando recolha...' : 'Salvar recolha'}}</span>
                    </button>
                    <button @click="editRecolha = false; confirmaFinalizar()" class="btn w-full inline-flex justify-center rounded-md shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 sm:ml-3 sm:w-auto sm:text-sm" :disabled="loading">
                        <span :class="loading ? 'animate-pulse' : ''"> {{loading ? 'Finalizando recolha...' : 'Finalizar recolha'}}</span>
                    </button>
                </div>
            </span>
        </div>
    </div>
</template>

<script>
import Input from '@/components/Design/Input'
import Autocomplete from '@/components/Design/Autocomplete'
import { GET_MODELOS_BY_MARCA, GET_MARCAS_BY_SEGMENTO, GET_COMPLEMENTOS_BY_MODELO, GET_PRODUTOS_BY_LOJA, GET_LOJAS_ATIVAS, GET_LOJA_ATIVA_BY_ID, DELETE_PRODUTOS_LOJA, POST_HISTORICO_CONTATOS_ATIVAS, POST_RECOLHA, POST_RECOLHA_EM_PROGRESSO } from '../../mixins/api.js'
import { computed, onMounted, ref } from 'vue'
import useVuelidate from '@vuelidate/core'
import { findId } from '../../mixins/findData.js'
import { useRoute } from 'vue-router'
import { displayNotification } from '../../mixins/notification.js'
import Remove from '../Pesquisa/ModalRemove.vue'
import Finalizar from '../Pesquisa/FinalizarModal.vue'
import Adicionar from '../Produtos/AdicionarProduto.vue'
import { Money3Directive, Money3Component } from 'v-money3'
import { useStore } from 'vuex'

export default {
    name: 'ListaProdutos',
    directives: { money3: Money3Directive },
    components: {
        money3: Money3Component,
        Input,
        Autocomplete,
        Remove,
        Adicionar,
        Finalizar
    },
    props: ['_recolha'],
    setup (props, { emit }) {
        const segmentos = ref([])
        const segmento = ref('')
        const marcas = ref([])
        const marca = ref('')
        const modelos = ref([])
        const modelo = ref('')
        const complementos = ref('')
        const complemento = ref('')
        const searchComplemento = ref('')

        const listProducts = ref([])
        const listProductsCopy = ref([])

        const store = useStore()
        const route = useRoute()

        const userViewer = store.getters['auth/user']

        const editRecolha = ref(false)

        const hasRecolha = ref(false)
        const recolha = computed(() => {
            return props._recolha
        })

        const filterByMarca = async () => {
            if (marca.value === '') {
                modelo.value = ''
                listProducts.value = listProductsCopy.value
            } else {
                const id = findId(marcas.value, marca.value, 'marca')
                await GET_MODELOS_BY_MARCA(id).then(r => {
                    modelos.value = r.data
                })
                listProducts.value = listProducts.value.filter(x => x.marca.toLowerCase() === marca.value.toLowerCase())
            }
        }

        const filterByModelo = async () => {
            if (modelo.value === '') {
                listProducts.value = listProducts.value.filter(x => x.marca.toLowerCase() === marca.value.toLowerCase())
            } else {
                const id = findId(modelos.value, modelo.value, 'descricao')
                await GET_COMPLEMENTOS_BY_MODELO(id).then(r => {
                    complementos.value = r.data
                })
                listProducts.value = listProducts.value.filter(x => x.modelo_descricao === modelo.value)
            }
        }

        const getInfo = (marcaId, modeloId, complementoId, field) => {
            const filtered = recolha.value.historico.filter(x => x.marca_id === marcaId && x.modelo_id === modeloId && x.complemento_id === complementoId)
            if (filtered.length === 0) {
                return 0
            }
            return filtered[0][field]
        }

        const filteredListProducts = computed(() => {
            if (marca.value === '') {
                return listProducts.value
            }
            if (modelo.value === '') {
                return listProducts.value
            }
            if (searchComplemento.value === '') {
                return listProducts.value
            }
            if (listProducts.value.length === 0) { return listProducts.value }
            return listProducts.value.filter(x => x.complemento.toLowerCase().includes(searchComplemento.value.toLowerCase()))
        })

        const getProducts = async () => {
            await GET_PRODUTOS_BY_LOJA(loja.value.id).then(r => {
                listProducts.value = r.data
                console.log(listProducts.value)
            })
            recolha.value.historico.push(...listProducts.value.map(p => {
                if (!recolha.value.historico.some(n => n.marca_id === p.marca_id && n.modelo_id === p.modelo_id && n.complemento_id === p.complemento_id)) {
                    const obj = { ...p }
                    obj.quantidade = 0
                    obj.valor = 0.00
                    return obj
                }
            }))
            recolha.value.historico = recolha.value.historico.filter(p => p !== undefined)
            listProducts.value = recolha.value.historico
        }
        const initialLoading = ref(false)
        const loja = ref({})
        onMounted(async () => {
            initialLoading.value = true
            await GET_LOJA_ATIVA_BY_ID(route.params.id).then(r => {
                loja.value = r.data.data
            })

            await GET_MARCAS_BY_SEGMENTO(loja.value.segmento_id).then(r => {
                marcas.value = r.data
            })
            await getProducts()
            initialLoading.value = false

            if (recolha.value) {
                hasRecolha.value = true
            }
        })

        const rules = computed(() => {
            return {
                segmento:
                    { uincludes: (value) => segmentos.value.map(a => a.descricao).includes(value.value) }

            }
        })
        const v$ = useVuelidate(rules, { segmento })

        const removeModal = ref(false)
        const finalizarModal = ref(false)
        const productToRemove = ref({})
        const openRemoveModal = (marca_id, modelo_id, complemento_id) => {
            productToRemove.value.marca_id = marca_id
            productToRemove.value.modelo_id = modelo_id
            productToRemove.value.complemento_id = complemento_id
            removeModal.value = true
        }

        const remove = async () => {
            await removeProduct(productToRemove.value.marca_id, productToRemove.value.modelo_id, productToRemove.value.complemento_id)
            removeModal.value = false
        }

        const removeProduct = async (marca_id, modelo_id, complemento_id) => {
            await DELETE_PRODUTOS_LOJA(loja.value.id, { marca_id, modelo_id, complemento_id }).then(r => {
                displayNotification(r)
                getProducts()
            }).catch(e => {
                displayNotification(e.response)
            })
        }

        const cancelEdit = () => {
            listProducts.value = listProductsCopy.value
        }

        const getCurrentDate = (() => {
            const date = new Date()
            return `${date.getFullYear()}-${(date.getMonth()+1 <= 9 ? '0'+(date.getMonth()+1) : date.getMonth()+1)}-${(date.getDate() <= 9 ? '0'+date.getDate() : date.getDate())} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`
        })

        const confirmaFinalizar = () => {
            if (userViewer.role === 'administrador') {
                finalizar()
            } else {
                finalizarModal.value = true
            }
        }

        const loading = ref(false)
        const finalizar = async () => {
            loading.value = true
            finalizarModal.value = false
            const body = {
                recolha: {
                    loja_id: loja.value.id,
                    ano_mes: recolha.value.recolha.ano_mes
                },
                produtos: listProducts.value.map(p => ({
                    marca_id: p.marca_id,
                    modelo_id: p.modelo_id,
                    complemento_id: p.complemento_id,
                    quantidade: p.quantidade,
                    valor: p.valor,
                    observacao: p.observacao
                }))

            }
            POST_RECOLHA(body).then(async r => {
                
                displayNotification(r)

                const hist = {
                    status_id: 12,
                    data: getCurrentDate(),
                    ano_mes: recolha.value.recolha.ano_mes,
                    observacao: 'Edição de recolha',
                    pesquisador_id: userViewer.id,
                    nome_contato_loja: '',
                    loja_id: loja.value.id,
                    cnpj: loja.value.cnpj
                }
                editRecolha.value = false
                await POST_HISTORICO_CONTATOS_ATIVAS(hist).then(r => {
                    
                    displayNotification(r)
                    sessionStorage.removeItem('historico')
                    editRecolha.value = false
                }).catch(e => {
                    displayNotification(e.response)
                })
            }).catch(e => {
                displayNotification(e.response)
            })
            loading.value = false
            emit('changeStatus')
        }

        const wip = async () => {
            loading.value = true
            const body = {
                recolha: {
                    loja_id: loja.value.id,
                    ano_mes: recolha.value.recolha.ano_mes
                },
                produtos: listProducts.value.map(p => ({
                    marca_id: p.marca_id,
                    modelo_id: p.modelo_id,
                    complemento_id: p.complemento_id,
                    quantidade: p.quantidade,
                    valor: p.valor,
                    observacao: p.observacao
                }))

            }
            await POST_RECOLHA_EM_PROGRESSO(body).then(r => {
                displayNotification(r)
            }).catch(e => {
                displayNotification(e.response)
            })
            loading.value = false
        }

        const percentCalc = (produto) => {
            const valor = produto.valor
            if (produto.preco_medio === 0) { return '' }
            if (valor > (1.2 * produto.preco_medio)) { return `${Math.round(parseFloat(valor) * 100 / parseFloat(produto.preco_medio)) - 100}%` } else { return `${100 - Math.round(parseFloat(valor) * 100 / parseFloat(produto.preco_medio))}%` }
        }

        const addModal = ref(false)

        const config = {
            prefix: '',
            suffix: '',
            thousands: '.',
            decimal: ',',
            precision: 2,
            disableNegative: false,
            disabled: false,
            min: null,
            max: null,
            allowBlank: false,
            minimumNumberOfCharacters: 0
        }

        return {
            config,
            segmentos,
            segmento,
            marcas,
            marca,
            modelos,
            modelo,
            complemento,
            complementos,
            searchComplemento,
            filteredListProducts,
            v$,
            filterByMarca,
            filterByModelo,
            listProducts,
            loja,
            openRemoveModal,
            remove,
            removeProduct,
            finalizarModal,
            removeModal,
            addModal,
            getProducts,
            percentCalc,
            editRecolha,
            getInfo,
            confirmaFinalizar,
            finalizar,
            wip,
            hasRecolha,
            recolha,
            initialLoading,
            cancelEdit,
            userViewer
        }
    }
}
</script>
<style>
</style>
